import React, { Component } from 'react'
import { Formik } from 'formik'
import { FormattedMessage } from 'react-intl'
import {
  EmailField,
  RoleField,
  PlantField,
  Buttons,
  OrganisationTypeField,
  FeatureFlagField,
  MakeField,
} from './Fields'
import { Flex, Typography } from 'antd'

const { Title } = Typography

export default class CreateUser extends Component {
  requestUserCreation = (formValues) => {
    const { createUser } = this.props
    const userData = {
      email: formValues.email,
      role: formValues.role,
      plant: formValues.plant,
      feature_flag: formValues.feature_flag,
      organisation_type: formValues.organisation_type ?? '',
      make: formValues.make,
    }
    createUser(userData)
  }

  validateForm = (values) => {
    const errors = {}
    if (!values.email || values.email.length === 0) {
      errors.email = 'Required'
    }
    if (!values.role || values.role.length === 0) {
      errors.role = 'Required'
    }
    if (!errors.role && !values.plant) {
      errors.plant = 'Required'
    }
    return errors
  }

  render() {
    const { customAttributes, isSaving } = this.props

    const { roles, plants, feature_flags, organisation_types, makes } =
      customAttributes

    const roleOptions = roles.map((role) => ({ value: role, label: role }))
    const plantOptions = plants.map((plant) => ({ value: plant, label: plant }))
    const featureFlagOptions = feature_flags.map((feature_flag) => ({
      value: feature_flag,
      label: feature_flag,
    }))
    const organisationTypeOptions = organisation_types.map(
      (organisation_type) => ({
        value: organisation_type,
        label: organisation_type,
      }),
    )
    const makeOptions = makes.map((make) => ({ value: make, label: make }))
    const selectedMakes = makes.map((make) => make)
    const initialValues = {
      email: '',
      role: '',
      plant: [],
      feature_flag: [],
      organisation_type: '',
      make: selectedMakes,
    }

    return (
      <Flex id="user-form-container" vertical={true} align="center" gap="small">
        <Title level={2}>
          <FormattedMessage id="users.addNewUser" />
        </Title>
        <Formik initialValues={initialValues} validate={this.validateForm}>
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <Flex vertical={true} gap="middle">
                <EmailField
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && errors.email}
                />

                <RoleField
                  options={roleOptions}
                  value={values.role}
                  onChange={(option) => setFieldValue('role', option)}
                  error={touched.role && errors.role}
                />

                <PlantField
                  role={values.role.value}
                  options={plantOptions}
                  onChange={(option) => setFieldValue('plant', option)}
                  value={values.plant}
                  error={touched.plant && errors.plant}
                />

                <FeatureFlagField
                  options={featureFlagOptions}
                  onChange={(option) => setFieldValue('feature_flag', option)}
                  value={values.feature_flag}
                  error={touched.feature_flag && errors.feature_flag}
                />

                <OrganisationTypeField
                  options={organisationTypeOptions}
                  value={values.organisation_type}
                  onChange={(option) =>
                    setFieldValue('organisation_type', option)
                  }
                  error={touched.organisation_type && errors.organisation_type}
                  hidden={true}
                  disabled={true}
                />

                <MakeField
                  options={makeOptions}
                  onChange={(option) => setFieldValue('make', option)}
                  value={values.make}
                  error={touched.make && errors.make}
                  hidden={true}
                  disabled={true}
                />

                <Buttons
                  isSaving={isSaving}
                  values={values}
                  onSubmit={this.requestUserCreation}
                />
              </Flex>
            </form>
          )}
        </Formik>
      </Flex>
    )
  }
}
